export default __webpack_public_path__ + "static/media/add_rooms.5c1c9ece.svg";